/**
 * Supabase Client
 * 
 * Creates and exports Supabase client for database access
 * Uses Firebase Auth tokens for authentication
 */

import { createClient } from '@supabase/supabase-js';
import { getCurrentUserToken } from './firebase';

// Get Supabase URL and anon key from environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 
                    import.meta.env.NEXT_PUBLIC_SUPABASE_URL ||
                    'https://mpnsolvrttovlhgtpqcz.supabase.co';

const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 
                        import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
                        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1wbnNvbHZydHRvdmxoZ3RwcWN6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc2MDMzODUsImV4cCI6MjA4MzE3OTM4NX0.E8rpnJ_bc2kkN8kE9_kD5VpOflpovJvXaijDeWQsNlc';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('⚠️ Supabase URL or Anon Key not found in environment variables');
}

// Supabase client for database access
// Note: Firebase Auth используется для аутентификации
// Supabase используется только для БД (jobs, videos, subscriptions)
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/**
 * Get current session token
 */
export const getSessionToken = async (): Promise<string | null> => {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.access_token || null;
};

/**
 * Store token in localStorage
 */
export const storeToken = (token: string) => {
  localStorage.setItem('jwt_token', token);
};

/**
 * Get token from localStorage
 */
export const getStoredToken = (): string | null => {
  return localStorage.getItem('jwt_token');
};

/**
 * Clear token from localStorage
 */
export const clearToken = () => {
  localStorage.removeItem('jwt_token');
};
